"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnsoldMintingOptions = exports.CollectionStatus = exports.Categories = exports.CollectionType = void 0;
/**
 * Collection types.
 */
var CollectionType;
(function (CollectionType) {
    CollectionType[CollectionType["CLASSIC"] = 0] = "CLASSIC";
    CollectionType[CollectionType["GENERATED"] = 1] = "GENERATED";
    CollectionType[CollectionType["SFT"] = 2] = "SFT";
    CollectionType[CollectionType["METADATA"] = 3] = "METADATA";
})(CollectionType || (exports.CollectionType = CollectionType = {}));
/**
 * Collection Categories.
 */
var Categories;
(function (Categories) {
    Categories["COLLECTIBLE"] = "COLLECTIBLE";
    Categories["PFP"] = "PFP";
    Categories["PHOTOGRAPHY"] = "PHOTOGRAPHY";
    Categories["ANIMATION"] = "ANIMATION";
    Categories["THREE_D"] = "3D";
    Categories["GENERATIVE"] = "GENERATIVE";
    Categories["SINGLE"] = "SINGLE";
    Categories["INTERACTIVE"] = "INTERACTIVE";
    Categories["ABSTRACT"] = "ABSTRACT";
    Categories["PIXELART"] = "PIXELART";
    Categories["GAME"] = "GAME";
    Categories["ART"] = "ART";
})(Categories || (exports.Categories = Categories = {}));
/**
 * Collection Status.
 */
var CollectionStatus;
(function (CollectionStatus) {
    CollectionStatus["PRE_MINTED"] = "pre_minted";
    CollectionStatus["MINTING"] = "minting";
    CollectionStatus["MINTED"] = "minted";
})(CollectionStatus || (exports.CollectionStatus = CollectionStatus = {}));
/**
 * Unsold Minting Options.
 */
var UnsoldMintingOptions;
(function (UnsoldMintingOptions) {
    UnsoldMintingOptions["BURN_UNSOLD"] = "burn_unsold";
    UnsoldMintingOptions["SET_NEW_PRICE"] = "set_new_price";
    UnsoldMintingOptions["KEEP_PRICE"] = "keep_price";
    UnsoldMintingOptions["TAKE_OWNERSHIP"] = "take_ownership";
})(UnsoldMintingOptions || (exports.UnsoldMintingOptions = UnsoldMintingOptions = {}));
